import Head from "next/head";
import { css } from "@emotion/react";
import { breakpoints } from "@mytutor/shared-react-web-components/lib/theme";
import Header from "@mytutor/mytutor-design-system/components/Header";
import { useGetCanonicalUrl } from "../../util/useGetCanonicalUrl";
import { UserContext } from "../../context/userContext";
import { useContext, useEffect, useState } from "react";
import { fetchUnreadMessageNumber } from "../../util/fetchUnreadMessageNumber";

const mainStyle = css`
  margin: 80px 0 0;
  .row {
    padding-left: 0px;
    padding-right: 0px;
    @media (min-width: ${breakpoints.tablet}px) {
      padding-left: 20px;
      padding-right: 20px;
    }
    @media (min-width: ${breakpoints.desktop}px) {
      display: block;
      max-width: 1400px;
      margin-right: auto;
      margin-left: auto;
      box-sizing: border-box;
    }
  }
`;

const Layout = ({ children, metadata, cookies }) => {
  const canonicalURL = useGetCanonicalUrl();
  const [hasMounted, setHasMounted] = useState(false);
  const { userDetails, isAuthenticated } = useContext(UserContext);
  const [unreadMessageNumber, setUnreadMessageNumber] = useState(0);
  // This is a hack to prevent the header from flashing on the screen
  // before the page is rendered. This is because the header is rendered
  // server-side, but the userDetails state is not available until the
  // page is rendered client-side.
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const handleLogout = async () => {
    try {
      await fetch("/view-tutors/api/logout/");
      window.location.reload();
    } catch (e) {
      console.warn(e);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchUnreadMessageNumber({
        userDetails,
        cookies,
        setUnreadMessageNumber,
      });
    }
  }, [userDetails, isAuthenticated]);

  return (
    <>
      <Head>
        <title>{`${metadata.documentTitle} | MyTutor`}</title>
        <meta name="description" content={metadata.metaDescription} />
        <link rel="canonical" href={canonicalURL} />
      </Head>
      {hasMounted && isAuthenticated ? (
        <Header
          user={userDetails}
          handleLogout={handleLogout}
          unreadMessageNumber={unreadMessageNumber}
        />
      ) : (
        <Header /> 
      )} 
      <main css={mainStyle}>{children}</main>
    </>
  );
};

export default Layout;
